<app-modal-header (closeModal)="close()"> </app-modal-header>
<app-modal-body>
  <h1 class="fs-5 text-truncate pe-2" [innerHTML]="'HOLD_ON' | translate"></h1>
  <p class="mb-0">
    {{ 'BY_UNARCHIVING_THIS_PERSON_THIS_PROFILE_WILL_BE_VISIBLE_AND_CAN_BE_VIEWED_ON_YOUR_MAIN_MENU' | translate }}
  </p>
</app-modal-body>
<app-modal-footer classList="d-flex justify-content-center">
  <button
    class="btn btn-primary fw-medium rounded-5 me-2"
    type="button"
    (click)="doUnarchive()"
    [disabled]="isHttpRequestRunning"
  >
    @if (isHttpRequestRunning) {
      <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
    }
    {{ 'YES_UNARCHIVE' | translate }}
  </button>
  <button
    class="btn fw-medium rounded-5"
    type="button"
    (click)="close()"
    [class.btn-outline-dark]="!isBgDarkMode"
    [class.btn-outline-light]="isBgDarkMode"
  >
    {{ 'NO_GO_BACK' | translate }}
  </button>
</app-modal-footer>
